import axios from "@/api/request";

const headerJSON = {
    "Content-Type": "application/json"
};
// FormData格式请求头
const headerFormData = {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};

const headerFileUpload={
  "Content-Type":"multipart/form-data"
}

let fmtParams=param=>{
    if(param.method==='post')
    {
        window.rad++;
        window.rad=window.rad%100;
        param.url=param.url+"?t="+new Date().getTime()+window.rad.toString();
    }
  if(!param.data&&param.data!=='')
    return param;
  if(typeof(param.data)==='string')
  {
      let dataForm = new FormData();
      dataForm.append('param', param.data);
      param.data=dataForm;
      param.header=headerFormData;
      return param;
  }
  else if(typeof(param.data)==='object') {
      if (!(param.data instanceof Array)) {
          let hasFile = false;
          let i=0;
          for(let key in param.data)
          {
              if(param.data.hasOwnProperty(key))
              {
                i++;
                if(param.data[key] instanceof File)
                {
                  hasFile=true;
                  break;
                }
              }
          }
          if(hasFile||i<2){
              let newForm = new FormData();
              for(let key in param.data)
              {
                  if(param.data.hasOwnProperty(key))
                  {
                      newForm.append(key, param.data[key]);
                  }
              }
              param.data=newForm;
          }
          if(hasFile)
          {
              param.header=headerFileUpload;
          }
          else if (i<2) {
              param.header=headerFormData;
          }
          else {
            param.header=headerJSON;
          }
          return param;
      }
  }
  return param;
}

export function getsatellitelist() {
  return axios(fmtParams({
    url: "/offline/lscreen/getsatellitelist",
    method: "get"
  }));
}


export function upload(data) {
    return axios(fmtParams({
        url: "/mvc/common-file/upload",
        method: "post",
        data:data
    }));
}

export function uploadNeedCheck(data) {
    return axios(fmtParams({
        url: "/mvc/common-file/uploadNeedCheck",
        method: "post",
        data:data
    }));
}

export function uploadOManager(data) {
    return axios(fmtParams({
        url: "/mvc/common-file/uploadOManager",
        method: "post",
        data:data
    }));
}

export function uploadProfessor(data) {
    return axios(fmtParams({
        url: "/mvc/common-file/uploadProfessor",
        method: "post",
        data:data
    }));
}

export function getFileList(data) {
    return axios(fmtParams({
        url: "/mvc/common-file/upload",
        method: "post",
        data:data
    }));
}

export function getTable(data) {
    return axios(fmtParams({
        url: "/mvc/common-file/get-table",
        method: "post",
        data:data
    }));
}

export function getRegionTree(data) {
    return axios(fmtParams({
        url: "/mvc/t-region/getRegionTree",
        method: "post",
        data:data
    }));
}

export function searchQuXianDic(data) {
    return axios(fmtParams({
        url: "/mvc/t-region/searchQuXianDic",
        method: "post",
        data:data
    }));
}

export function getChildRegion(data) {
    return axios(fmtParams({
        url: "/mvc/t-region/getChildRegion",
        method: "post",
        data:data
    }));
}

export function getRegion(data) {
    return axios(fmtParams({
        url: "/mvc/t-region/getRegion",
        method: "post",
        data:data
    }));
}

export function searchBadDic(data) {
    return axios(fmtParams({
        url: "/mvc/bad-things-std/searchBadDic",
        method: "post",
        data:data
    }));
}

export function getValByKey(data) {
    return axios(fmtParams({
        url: "/mvc/bad-things-std/getValByKey",
        method: "post",
        data:data
    }));
}

export function getOCheckerPage(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/getOCheckerPage",
        method: "post",
        data:data
    }));
}

export function delOCheckerSelected(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/delOCheckerSelected",
        method: "post",
        data:data
    }));
}

export function getOCheckerById(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/getOCheckerById",
        method: "post",
        data:data
    }));
}

export function addorUpdateOChecker(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/addorUpdateOChecker",
        method: "post",
        data:data
    }));
}

export function searchOCheckerDic(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/searchOCheckerDic",
        method: "post",
        data:data
    }));
}

export function searchOCheckerDic2(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/searchOCheckerDic2",
        method: "post",
        data:data
    }));
}

export function getValByOCheckerKey(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker/getValByOCheckerKey",
        method: "post",
        data:data
    }));
}

export function getOCheckerCardPage(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card/getOCheckerCardPage",
        method: "post",
        data:data
    }));
}

export function delOCheckerCardSelected(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card/delOCheckerCardSelected",
        method: "post",
        data:data
    }));
}

export function getOCheckerCardById(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card/getOCheckerCardById",
        method: "post",
        data:data
    }));
}

export function addorUpdateOCheckerCard(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card/addorUpdateOCheckerCard",
        method: "post",
        data:data
    }));
}

export function getDaoQiAlertInfo(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card/getDaoQiAlertInfo",
        method: "post",
        data:data
    }));
}


export function getOCheckerCardMsgRuleById(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card-msg-rule/getOCheckerCardMsgRuleById",
        method: "post",
        data:data
    }));
}

export function addorUpdateOCheckerCardMsgRule(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card-msg-rule/addorUpdateOCheckerCardMsgRule",
        method: "post",
        data:data
    }));
}

export function getProfessorPage(data) {
    return axios(fmtParams({
        url: "/mvc/professor/getProfessorPage",
        method: "post",
        data:data
    }));
}

export function getAllNew(data) {
    return axios(fmtParams({
        url: "/mvc/professor/getAllNew",
        method: "post",
        data:data
    }));
}

export function delProfessorSelected(data) {
    return axios(fmtParams({
        url: "/mvc/professor/delProfessorSelected",
        method: "post",
        data:data
    }));
}

export function getProfessorById(data) {
    return axios(fmtParams({
        url: "/mvc/professor/getProfessorById",
        method: "post",
        data:data
    }));
}

export function addorUpdateProfessor(data) {
    return axios(fmtParams({
        url: "/mvc/professor/addorUpdateProfessor",
        method: "post",
        data:data
    }));
}

export function addorUpdateProfessor2(data) {
    return axios(fmtParams({
        url: "/mvc/professor/addorUpdateProfessor2",
        method: "post",
        data:data
    }));
}


export function searchProfessorDic(data) {
    return axios(fmtParams({
        url: "/mvc/professor/searchProfessorDic",
        method: "post",
        data:data
    }));
}


export function setProfessor(data) {
    return axios(fmtParams({
        url: "/mvc/rending-professor-rel/setProfessor",
        method: "post",
        data:data
    }));
}


// export function getProfessorPage(data) {
//     return axios(fmtParams({
//         url: "/mvc/professor/getProfessorPage",
//         method: "post",
//         data:data
//     }));
// }
//
// export function delProfessorSelected(data) {
//     return axios(fmtParams({
//         url: "/mvc/professor/delProfessorSelected",
//         method: "post",
//         data:data
//     }));
// }
//
// export function getProfessorById(data) {
//     return axios(fmtParams({
//         url: "/mvc/professor/getProfessorById",
//         method: "post",
//         data:data
//     }));
// }
//
// export function addorUpdateProfessor(data) {
//     return axios(fmtParams({
//         url: "/mvc/professor/addorUpdateProfessor",
//         method: "post",
//         data:data
//     }));
// }
//
//
// export function searchProfessorDic(data) {
//     return axios(fmtParams({
//         url: "/mvc/professor/searchProfessorDic",
//         method: "post",
//         data:data
//     }));
// }
//
export function searchProfessorDicNew(data) {
    return axios(fmtParams({
        url: "/mvc/professor/searchProfessorDicNew",
        method: "post",
        data:data
    }));
}

export function getValByProfessorKey(data) {
    return axios(fmtParams({
        url: "/mvc/professor/getValByProfessorKey",
        method: "post",
        data:data
    }));
}

export function getDbRandomPage(data) {
    return axios(fmtParams({
        url: "/mvc/db-random/getDbRandomPage",
        method: "post",
        data:data
    }));
}

export function delDbRandomSelected(data) {
    return axios(fmtParams({
        url: "/mvc/db-random/delDbRandomSelected",
        method: "post",
        data:data
    }));
}

export function getDbRandomById(data) {
    return axios(fmtParams({
        url: "/mvc/db-random/getDbRandomById",
        method: "post",
        data:data
    }));
}

export function addorUpdateDbRandom(data) {
    return axios(fmtParams({
        url: "/mvc/db-random/addorUpdateDbRandom",
        method: "post",
        data:data
    }));
}

export function getMonitPlanPage(data) {
    return axios(fmtParams({
        url: "/mvc/monit-plan/getMonitPlanPage",
        method: "post",
        data:data
    }));
}

export function delMonitPlanSelected(data) {
    return axios(fmtParams({
        url: "/mvc/monit-plan/delMonitPlanSelected",
        method: "post",
        data:data
    }));
}

export function getMonitPlanById(data) {
    return axios(fmtParams({
        url: "/mvc/monit-plan/getMonitPlanById",
        method: "post",
        data:data
    }));
}

export function addorUpdateMonitPlan(data) {
    return axios(fmtParams({
        url: "/mvc/monit-plan/addorUpdateMonitPlan",
        method: "post",
        data:data
    }));
}

export function searchStdBadDic(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/searchStdBadDic",
        method: "post",
        data:data
    }));
}

export function publishStdBad(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/publishStdBad",
        method: "post",
        data:data
    }));
}

export function stopStdBad(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/stopStdBad",
        method: "post",
        data:data
    }));
}

export function restartStdBad(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/restartStdBad",
        method: "post",
        data:data
    }));
}

export function getValByStdBadKey(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/getValByStdBadKey",
        method: "post",
        data:data
    }));
}

export function searchStdJudgeDic(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/searchStdJudgeDic",
        method: "post",
        data:data
    }));
}

export function publishStdJudge(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/publishStdJudge",
        method: "post",
        data:data
    }));
}

export function stopStdJudge(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/stopStdJudge",
        method: "post",
        data:data
    }));
}

export function restartStdJudge(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/restartStdJudge",
        method: "post",
        data:data
    }));
}


export function publishStdLimit(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/publishStdLimit",
        method: "post",
        data:data
    }));
}

export function stopStdLimit(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/stopStdLimit",
        method: "post",
        data:data
    }));
}

export function restartStdLimit(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/restartStdLimit",
        method: "post",
        data:data
    }));
}


export function publishStdProduce(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/publishStdProduce",
        method: "post",
        data:data
    }));
}

export function stopStdProduce(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/stopStdProduce",
        method: "post",
        data:data
    }));
}

export function restartStdProduce(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/restartStdProduce",
        method: "post",
        data:data
    }));
}

export function getValByStdJudgeKey(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/getValByStdJudgeKey",
        method: "post",
        data:data
    }));
}

export function searchStdLimitDic(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/searchStdLimitDic",
        method: "post",
        data:data
    }));
}

export function getValByStdLimitKey(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/getValByStdLimitKey",
        method: "post",
        data:data
    }));
}

export function searchStdProduceDic(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/searchStdProduceDic",
        method: "post",
        data:data
    }));
}

export function getValByStdProduceKey(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/getValByStdProduceKey",
        method: "post",
        data:data
    }));
}

export function stopProject(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/stopProject",
        method: "post",
        data:data
    }));
}

export function getMonitProjectPage(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/getMonitProjectPage",
        method: "post",
        data:data
    }));
}

export function searchProjectBadDic(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/searchProjectBadDic",
        method: "post",
        data:data
    }));
}

export function delMonitProjectSelected(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/delMonitProjectSelected",
        method: "post",
        data:data
    }));
}

export function getMonitProjectById(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/getMonitProjectById",
        method: "post",
        data:data
    }));
}

export function getMonitTaskById2(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/getMonitTaskById",
        method: "post",
        data:data
    }));
}


export function addorUpdateMonitProject(data) {
    return axios(fmtParams({
        url: "/mvc/monit-project/addorUpdateMonitProject",
        method: "post",
        data:data
    }));
}


export function getMonitTaskPage(data) {
    return axios(fmtParams({
        url: "/mvc/monit-task/getMonitTaskPage",
        method: "post",
        data:data
    }));
}

export function delMonitTaskSelected(data) {
    return axios(fmtParams({
        url: "/mvc/monit-task/delMonitTaskSelected",
        method: "post",
        data:data
    }));
}

export function getMonitTaskById(data) {
    return axios(fmtParams({
        url: "/mvc/monit-task/getMonitTaskById",
        method: "post",
        data:data
    }));
}

export function addorUpdateMonitTask(data) {
    return axios(fmtParams({
        url: "/mvc/monit-task/addorUpdateMonitTask",
        method: "post",
        data:data
    }));
}

export function searchTaskProduceDic(data) {
    return axios(fmtParams({
        url: "/mvc/monit-task/searchTaskProduceDic",
        method: "post",
        data:data
    }));
}

export function searchTaskLinkDic(data) {
    return axios(fmtParams({
        url: "/mvc/monit-task/searchTaskLinkDic",
        method: "post",
        data:data
    }));
}

export function publishMonitPick(data) {
    return axios(fmtParams({
        url: "/mvc/monit-pick/publishMonitPick",
        method: "post",
        data:data
    }));
}

export function getPublishMonitPick(data) {
    return axios(fmtParams({
        url: "/mvc/monit-pick/getPublishMonitPick",
        method: "post",
        data:data
    }));
}


export function getMonitPickPage(data) {
    return axios(fmtParams({
        url: "/mvc/monit-pick/getMonitPickPage",
        method: "post",
        data:data
    }));
}

export function delMonitPickSelected(data) {
    return axios(fmtParams({
        url: "/mvc/monit-pick/delMonitPickSelected",
        method: "post",
        data:data
    }));
}

export function getMonitPickById(data) {
    return axios(fmtParams({
        url: "/mvc/monit-pick/getMonitPickById",
        method: "post",
        data:data
    }));
}

export function addorUpdateMonitPick(data) {
    return axios(fmtParams({
        url: "/mvc/monit-pick/addorUpdateMonitPick",
        method: "post",
        data:data
    }));
}

export function getONeedCheckerPage(data) {
    return axios(fmtParams({
        url: "/mvc/o-need-checker/getONeedCheckerPage",
        method: "post",
        data:data
    }));
}

export function delONeedCheckerSelected(data) {
    return axios(fmtParams({
        url: "/mvc/o-need-checker/delONeedCheckerSelected",
        method: "post",
        data:data
    }));
}

export function getONeedCheckerById(data) {
    return axios(fmtParams({
        url: "/mvc/o-need-checker/getONeedCheckerById",
        method: "post",
        data:data
    }));
}

export function addorUpdateONeedChecker(data) {
    return axios(fmtParams({
        url: "/mvc/o-need-checker/addorUpdateONeedChecker",
        method: "post",
        data:data
    }));
}

export function getStdBadPage(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/getStdBadPage",
        method: "post",
        data:data
    }));
}

export function delStdBadSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/delStdBadSelected",
        method: "post",
        data:data
    }));
}

export function getStdBadById(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/getStdBadById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdBad(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad/addorUpdateStdBad",
        method: "post",
        data:data
    }));
}

export function getStdProducePage(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/getStdProducePage",
        method: "post",
        data:data
    }));
}

export function delStdProduceSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/delStdProduceSelected",
        method: "post",
        data:data
    }));
}

export function getStdProduceById(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/getStdProduceById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdProduce(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce/addorUpdateStdProduce",
        method: "post",
        data:data
    }));
}


export function getStdLimitPage(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/getStdLimitPage",
        method: "post",
        data:data
    }));
}

export function delStdLimitSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/delStdLimitSelected",
        method: "post",
        data:data
    }));
}

export function getStdLimitById(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/getStdLimitById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdLimit(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit/addorUpdateStdLimit",
        method: "post",
        data:data
    }));
}

export function getStdJudgePage(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/getStdJudgePage",
        method: "post",
        data:data
    }));
}

export function delStdJudgeSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/delStdJudgeSelected",
        method: "post",
        data:data
    }));
}

export function getStdJudgeById(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/getStdJudgeById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdJudge(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge/addorUpdateStdJudge",
        method: "post",
        data:data
    }));
}

export function getOManagerPage(data) {
    return axios(fmtParams({
        url: "/mvc/o-manager/getOManagerPage",
        method: "post",
        data:data
    }));
}

export function delOManagerSelected(data) {
    return axios(fmtParams({
        url: "/mvc/o-manager/delOManagerSelected",
        method: "post",
        data:data
    }));
}

export function getOManagerById(data) {
    return axios(fmtParams({
        url: "/mvc/o-manager/getOManagerById",
        method: "post",
        data:data
    }));
}

export function addorUpdateOManager(data) {
    return axios(fmtParams({
        url: "/mvc/o-manager/addorUpdateOManager",
        method: "post",
        data:data
    }));
}

export function getOPickTmplPage(data) {
    return axios(fmtParams({
        url: "/mvc/o-pick-tmpl/getOPickTmplPage",
        method: "post",
        data:data
    }));
}

export function delOPickTmplSelected(data) {
    return axios(fmtParams({
        url: "/mvc/o-pick-tmpl/delOPickTmplSelected",
        method: "post",
        data:data
    }));
}

export function getOPickTmplById(data) {
    return axios(fmtParams({
        url: "/mvc/o-pick-tmpl/getOPickTmplById",
        method: "post",
        data:data
    }));
}

export function addorUpdateOPickTmpl(data) {
    return axios(fmtParams({
        url: "/mvc/o-pick-tmpl/addorUpdateOPickTmpl",
        method: "post",
        data:data
    }));
}

export function searchOPickTmplDic(data) {
    return axios(fmtParams({
        url: "/mvc/o-pick-tmpl/searchOPickTmplDic",
        method: "post",
        data:data
    }));
}

export function searchProduceItem(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce-item/searchProduceItem",
        method: "post",
        data:data
    }));
}

export function searchProduceItemTree(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce-item/searchProduceItemTree",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdProduceItem(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce-item/addorUpdateStdProduceItem",
        method: "post",
        data:data
    }));
}

export function delStdProduceItemSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce-item/delStdProduceItemSelected",
        method: "post",
        data:data
    }));
}

export function getStdProduceItemById(data) {
    return axios(fmtParams({
        url: "/mvc/std-produce-item/getStdProduceItemById",
        method: "post",
        data:data
    }));
}


export function getStdBadDicPage(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-dic/getStdBadDicPage",
        method: "post",
        data:data
    }));
}

export function delStdBadDicSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-dic/delStdBadDicSelected",
        method: "post",
        data:data
    }));
}

export function getStdBadDicById(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-dic/getStdBadDicById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdBadDic(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-dic/addorUpdateStdBadDic",
        method: "post",
        data:data
    }));
}

export function getStdBadClassifyPage(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-classify/getStdBadClassifyPage",
        method: "post",
        data:data
    }));
}

export function delStdBadClassifySelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-classify/delStdBadClassifySelected",
        method: "post",
        data:data
    }));
}

export function getStdBadClassifyById(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-classify/getStdBadClassifyById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdBadClassify(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-classify/addorUpdateStdBadClassify",
        method: "post",
        data:data
    }));
}

export function searchBadItemTree(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-classify/searchBadItemTree",
        method: "post",
        data:data
    }));
}

export function addRel(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-rel/addRel",
        method: "post",
        data:data
    }));
}

export function delStdBadRelSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-bad-rel/delStdBadRelSelected",
        method: "post",
        data:data
    }));
}

export function getStdLimitItemPage(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit-item/getStdLimitItemPage",
        method: "post",
        data:data
    }));
}

export function delStdLimitItemSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit-item/delStdLimitItemSelected",
        method: "post",
        data:data
    }));
}

export function getStdLimitItemById(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit-item/getStdLimitItemById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdLimitItem(data) {
    return axios(fmtParams({
        url: "/mvc/std-limit-item/addorUpdateStdLimitItem",
        method: "post",
        data:data
    }));
}

export function getStdJudgeItemPage(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge-item/getStdJudgeItemPage",
        method: "post",
        data:data
    }));
}

export function delStdJudgeItemSelected(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge-item/delStdJudgeItemSelected",
        method: "post",
        data:data
    }));
}

export function getStdJudgeItemById(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge-item/getStdJudgeItemById",
        method: "post",
        data:data
    }));
}

export function addorUpdateStdJudgeItem(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge-item/addorUpdateStdJudgeItem",
        method: "post",
        data:data
    }));
}

export function UpdateBatchStdJudgeItem(data) {
    return axios(fmtParams({
        url: "/mvc/std-judge-item/UpdateBatchStdJudgeItem",
        method: "post",
        data:data
    }));
}


export function getMonitCheckPage(data) {
    return axios(fmtParams({
        url: "/mvc/monit-check/getMonitCheckPage",
        method: "post",
        data:data
    }));
}

export function reportMonitCheck(data) {
    return axios(fmtParams({
        url: "/mvc/monit-check/reportMonitCheck",
        method: "post",
        data:data
    }));
}

export function getMonitCheckReportInfo(data) {
    return axios(fmtParams({
        url: "/mvc/monit-check/getMonitCheckReportInfo",
        method: "post",
        data:data
    }));
}

export function getMonitCheckResultPage(data) {
    return axios(fmtParams({
        url: "/mvc/monit-check-result/getMonitCheckResultPage",
        method: "post",
        data:data
    }));
}

export function getMonitCheckResult2Page(data) {
    return axios(fmtParams({
        url: "/mvc/monit-check-result/getMonitCheckResult2Page",
        method: "post",
        data:data
    }));
}

export function getTaskMonitDetail(data) {
    return axios(fmtParams({
        url: "/mvc/monit-check-result/getTaskMonitDetail",
        method: "post",
        data:data
    }));
}

export function addorUpdateOCheckerCardMsgSend(data) {
    return axios(fmtParams({
        url: "/mvc/o-checker-card-msg-send/addorUpdateOCheckerCardMsgSend",
        method: "post",
        data:data
    }));
}
// 随机组长和组员
export function randomLeaderAndNumber(data) {
    return axios(fmtParams({
        url: "/mvc/professor/randomProfessor",
        method: "post",
        data:data
    }));
}
// 保存抽查纪律
export function saveRecords(data) {
    return axios(fmtParams({
        url: "/mvc/professor/addSpotCheckHis",
        method: "post",
        data:data
    }));
}
// 查询随机记录
export function getRecordList() {
    return axios(fmtParams({
        url: "/mvc/professor/SpotCheckHisList",
        method: "get",
    }));
}
